<!-- ========================================================================================
      Author: Alizadeh
========================================================================================== -->

<!-- <template src="./Bills.html">-->
<template>
  <div>
    <vs-collapse class="p-0 m-0 bg-white" type="margin">
      <vs-collapse-item icon-pack="feather" icon-arrow="icon-chevron-down">
        <div slot="header">
          <feather-icon
            icon="FilterIcon"
            svgClasses="text-primary"
          ></feather-icon
          >فیلترها
        </div>
        <div class="vx-row mb-2">
          <div class="vx-col sm:w-2/12 flex-inline ml-5">
            <span>فیلتر:</span>
          </div>
          <div class="vx-col sm:w-8/12 flex-inline">
            <vs-input
              v-model="filter"
              class="w-full"
              @keyup.enter="
                pageNo = 1;
                getData();
              "
            />
          </div>
        </div>
        <div class="vx-row mb-2">
          <div class="vx-col sm:w-2/12 flex-inline ml-5">
            <span>آرشیو:</span>
          </div>
          <div class="vx-col sm:w-8/12 flex-inline">
            <v-select
              v-model="selectedIsArchive"
              :options="ArchiveStateList"
            ></v-select>
          </div>
        </div>
        <div class="vx-row mb-2">
          <div class="vx-col sm:w-2/12 flex-inline ml-5">
            <span>نوع درخواست:</span>
          </div>
          <div class="vx-col sm:w-8/12 flex-inline">
            <!-- <vs-input v-model="filters.paymentType" class="w-full" /> -->
            <v-select
              class="selectExample w-full mb-1"
              v-model="draftTypeFilter"
              :options="draftTypeList"
            ></v-select>
          </div>
        </div>
        <div class="vx-row mb-2">
          <div class="vx-col sm:w-2/12 flex-inline ml-5">
            <span>وضعیت:</span>
          </div>
          <div class="vx-col sm:w-8/12 flex-inline">
            <!-- <vs-input v-model="filters.paymentType" class="w-full" /> -->
            <v-select
              multiple
              class="selectExample w-full mb-1"
              v-model="stepFilter"
              :options="draftStepList"
            ></v-select>
            <v-select
              multiple
              class="selectExample w-full"
              v-model="stateFilter"
              :options="draftStateList"
            ></v-select>
          </div>
        </div>
        <div class="vx-row mb-2">
          <div class="vx-col">
            <vs-button @click="clear" class="mx-3" color="primary" type="border"
              >پاک کردن</vs-button
            >
          </div>
          <div class="vx-col">
            <vs-button
              @click="
                pageNo = 1;
                getData();
              "
              class="mx-3"
              color="primary"
              type="filled"
              icon-pack="feather"
              icon="icon-search"
              >جستجو</vs-button
            >
          </div>
        </div>
      </vs-collapse-item>
    </vs-collapse>

    <vx-card class="mb-2">
      <vs-table
        id="tbl2"
        ref="tbl2"
        :data="transactions2"
        class="table-dark-inverted"
        @selected="selected"
      >
        <template slot="header">
          <div class="vx-row mb-2 w-full">
            <div class="vx-col sm:w-2/3 flex-inline">
              <div class="vx-row mb-2">
                <div class="vx-col">
                  <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                    <vs-dropdown vs-trigger-click class="cursor-pointer">
                      <div
                        class="
                          p-3
                          border border-solid
                          d-theme-border-grey-light
                          rounded-full
                          d-theme-dark-bg
                          cursor-pointer
                          flex
                          items-center
                          justify-between
                          font-medium
                        "
                      >
                        <span class="mr-2">
                          {{ (pageNo - 1) * pageSize + 1 }}
                          -
                          {{
                            pageNo * pageSize > totalCount
                              ? totalCount
                              : pageNo * pageSize
                          }}
                          از {{ totalCount }}
                        </span>
                        <feather-icon
                          icon="ChevronDownIcon"
                          svgClasses="h-4 w-4"
                        />
                      </div>
                      <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                      <vs-dropdown-menu>
                        <vs-dropdown-item @click="SetPageSize(5)">
                          <span>5</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(10)">
                          <span>10</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(20)">
                          <span>20</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(50)">
                          <span>50</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(100)">
                          <span>100</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(150)">
                          <span>150</span>
                        </vs-dropdown-item>
                      </vs-dropdown-menu>
                    </vs-dropdown>
                  </div>
                </div>
              </div>
            </div>

            <div class="vx-col sm:w-1/3 flex-inline">
              <vs-button
                style="float: left"
                @click="newMerchant()"
                class="mx-3"
                color="dark"
                type="border"
                icon-pack="feather"
                icon="icon-plus"
                >جدید</vs-button
              >
            </div>
          </div>
        </template>
        <template slot="thead">
          <vs-th></vs-th>
          <vs-th>شماره همراه</vs-th>
          <vs-th>نام</vs-th>
          <vs-th>نام خانوادگی</vs-th>
          <vs-th>فروشگاه</vs-th>
          <vs-th>کد پذیرندگی</vs-th>
          <vs-th>تاریخ درخواست</vs-th>
          <vs-th>تاریخ ویرایش</vs-th>
          <vs-th sort-key="state" key="state">وضعیت</vs-th>
          <vs-th></vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr
            :data="tr"
            :key="tr.id"
            v-for="(tr, indextr) in data"
            :style="tr.isDeleted ? { opacity: '0.4' } : {}"
          >
            <!-- <vs-td>
              <feather-icon
                :title="PaymentType[tr.transaction.paymentType].title"
                :icon="PaymentType[tr.transaction.paymentType].icon"
                svgClasses="h-6 w-6"
              ></feather-icon>
              <span>{{PaymentType[tr.transaction.paymentType].title}}</span>
            </vs-td>-->
            <vs-td class="mx-0 pr-0">
              <feather-icon
                :title="DraftType[tr.type].title"
                :icon="DraftType[tr.type].icon"
                :svgClasses="[`h-6 w-6 stroke-current text-${
                  DraftType[tr.type].color
                }`]"
              ></feather-icon>
            </vs-td>
            <vs-td>
              <span>{{ tr.draftMerchant.cellPhoneNumber }}</span>
            </vs-td>
            <vs-td>
              <span>{{ tr.draftMerchant.firstNameFa }}</span>
            </vs-td>
            <vs-td>
              <span>{{ tr.draftMerchant.lastNameFa }}</span>
            </vs-td>
            <vs-td>
              <span>{{ tr.pspRequestShopAcceptors[0].shop.farsiName }}</span>
            </vs-td>
            <vs-td>
              <span>{{
                tr.pspRequestShopAcceptors[0].acceptors[0].acceptorCode
              }}</span>
            </vs-td>
            <vs-td
              :title="$moment(tr.creationTime).format('HH:mm:ss - jYYYY/jM/jD')"
              >{{
                !tr.creationTime
                  ? "&nbsp;"
                  : $moment(tr.creationTime).format("HH:mm:ss jYYYY/jM/jD")
              }}</vs-td
            >
            <vs-td
              :title="$moment(tr.creationTime).format('HH:mm:ss - jYYYY/jM/jD')"
              >{{
                !tr.lastModificationTime
                  ? "&nbsp;"
                  : $moment(tr.lastModificationTime).format(
                      "HH:mm:ss jYYYY/jM/jD"
                    )
              }}</vs-td
            >
            <vs-td class="pl-0 pr-0">
              <tippy :to="'status' + tr.id" arrow class="statuses">
                <draft-merchant-current-status
                  :stepNo="tr.step"
                  :stateNo="tr.state"
                ></draft-merchant-current-status>
                <hr style="width: 100%" />
                <span style="color: rgb(255, 255, 255)">{{
                  (DraftStep[tr.step] || false).title +
                  " / " +
                  (DraftState[tr.state] || false).title
                }}</span>
              </tippy>
              <div :name="'status' + tr.id">
                <vs-chip
                  :color="DraftStep[tr.step].color"
                  class="product-order-status one-line"
                  >{{ (DraftStep[tr.step] || false).title }}</vs-chip
                >
                <br />
                <vs-chip
                  :color="DraftState[tr.state].color"
                  class="product-order-status one-line"
                  >{{ (DraftState[tr.state] || false).title }}</vs-chip
                >
              </div>
            </vs-td>
            <vs-td>
              <vs-dropdown>
                <a class="flex items-center" href.prevent>
                  عملیات
                  <i class="material-icons">expand_more</i>
                </a>
                <vs-dropdown-menu>
                  <!--edit for IncomplateFile,ComplateFile -->
                  <vs-dropdown-item
                    v-if="[0, 1, 2, 3].includes(tr.state)"
                    @click="editMerchent(tr)"
                    >ویرایش</vs-dropdown-item
                  >
                  <vs-dropdown-item
                    @click="showEditMobile(tr)"
                    v-if="[0, 1, 2, 3].includes(tr.state) && tr.step == 1"
                    >تغییر شماره همراه
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="editStatus(tr, false)"
                    >تغییر وضعیت</vs-dropdown-item
                  >
                  <vs-dropdown-item
                    v-if="
                      [1, 13, 5].includes(tr.step) &&
                      [0, 1, 2, 3, 5].includes(tr.state)
                    "
                    @click="serverValidation(tr.id, tr.step, tr.state)"
                    >بررسی نقص اطلاعات</vs-dropdown-item
                  >
                  <vs-dropdown-item v-if="!tr.isDeleted" @click="archive(tr.id)"
                    >آرشیو</vs-dropdown-item
                  >
                  <vs-dropdown-item
                    v-if="tr.isDeleted"
                    @click="unArchive(tr.id)"
                    >بازگردانی</vs-dropdown-item
                  >

                  <!--sendToPsp -->
                  <vs-dropdown-item
                    v-if="tr.step == 1 && [3, 5, 500].includes(tr.state)"
                    @click="sendToPsp(tr.id)"
                    >ارسال درخواست به psp</vs-dropdown-item
                  >

                  <!--send Shop To Shaparak -->
                  <vs-dropdown-item
                    v-if="tr.step == 13 && [3, 5, 500].includes(tr.state)"
                    @click="sendShopToShaparak(tr.id)"
                    >ثبت شاپرک</vs-dropdown-item
                  >
                  <vs-dropdown-item
                    v-if="tr.step == 13 && [8].includes(tr.state)"
                    @click="inquiry(tr.id, 13)"
                    >استعلام فروشگاه</vs-dropdown-item
                  >

                  <!--send Terminal To Shaparak -->
                  <vs-dropdown-item
                    v-if="tr.step == 5 && [3, 5, 500].includes(tr.state)"
                    @click="sendTerminalToShaparak(tr.id)"
                    >ثبت ترمینال</vs-dropdown-item
                  >
                  <vs-dropdown-item
                    v-if="[8].includes(tr.state)"
                    @click="inquiry(tr.id, 5)"
                    >استعلام</vs-dropdown-item
                  >
                  <vs-dropdown-item
                    @click="
                      showAsignPromoter(
                        tr.id,
                        tr.pspRequestShopAcceptors[0].shop.farsiName ||
                          tr.draftMerchant.cellPhoneNumber
                      )
                    "
                    >تعیین بازاریاب</vs-dropdown-item
                  >
                </vs-dropdown-menu>
              </vs-dropdown>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <paginate
        v-model="pageNo"
        :page-count="pagesCount"
        :click-handler="getData"
      />
      <create-or-edit-draft-merchant
        ref="CreateOrEditDraftMerchant1"
        @success="getData"
      />
      <edit-status-draft-merchant
        ref="EditStatusDraftMerchan1"
        @success="getData"
      />
      <edit-mobile ref="EditMobile1" @success="getData" />
      <management-ibans ref="ManagementIbans1" />
      <select-promoter
        ref="SelectPromoter1"
        @assign="assignPromoter"
        @unassign="unassignPromoter"
      />
    </vx-card>
  </div>
</template>
<style>
.tippy-popper .tippy-tooltip {
  background-color: rgba(255, 103, 32, 1);
}
.tippy-arrow {
  border-bottom-color: rgba(255, 103, 32, 1) !important;
  border-top-color: rgba(255, 103, 32, 1) !important;
}
.tippy-tooltip {
  max-width: initial !important;
}
</style>
<script>
import vSelect from "vue-select";
import {
  DraftStep,
  DraftState,
  RequestRejectionReason,
  DraftType,
} from "@/enums.js";
import CreateOrEditDraftMerchant from "./edit-draft/CreateOrEditDraftMerchant.vue";
import EditStatusDraftMerchan from "./EditStatusDraftMerchan.vue";
import DraftMerchantCurrentState from "./DraftMerchantCurrentState.vue";
import SelectPromoter from "../promoter/SelectPromoter.vue";
import EditMobile from "./EditMobile.vue";
import ManagementIbans from "../draft/ManagementIbans.vue";
import Vue from "vue";
import VueTippy, { TippyComponent } from "vue-tippy";
Vue.use(VueTippy);
export default {
  props: {
    transactions: {},
  },
  components: {
    "v-select": vSelect,
    "create-or-edit-draft-merchant": CreateOrEditDraftMerchant,
    "edit-status-draft-merchant": EditStatusDraftMerchan,
    "draft-merchant-current-status": DraftMerchantCurrentState,
    "edit-mobile": EditMobile,
    "select-promoter": SelectPromoter,
    tippy: TippyComponent,
    ManagementIbans,
  },
  data() {
    return {
      transactions2: [],
      DraftStep,
      DraftState,
      DraftType,
      totalCount: 1,
      pageSize: 20,
      pagesCount: 1,
      pageNo: 1,
      stepFilter: [],
      stateFilter: [],
      draftTypeFilter: null,
      filter: "",
      editingRecord: undefined,
      selectedIsArchive: { label: "درخواستهای جاری", value: false },
      ArchiveStateList: [
        { label: "درخواستهای جاری", value: false },
        { label: "آرشیو شده", value: true },
      ],
    };
  },
  computed: {
    draftTypeList: function () {
      let ms = [];
      for (let [key, value] of Object.entries(this.DraftType)) {
        ms.push({ value: key, label: value.title });
      }
      return ms;
    },
    draftStepList: function () {
      let ms = [];
      for (let [key, value] of Object.entries(this.DraftStep)) {
        ms.push({ value: key, label: value.title });
      }
      return ms;
    },
    draftStateList: function () {
      let ms = [];
      for (let [key, value] of Object.entries(this.DraftState)) {
        ms.push({ value: key, label: value.title });
      }
      return ms;
    },
  },
  methods: {
    initFilters() {
      if (Object.keys(this.$route.query).length != 0) {
        this.pageSize = this.$route.query.ps || this.pageSize;
        this.pageNo = parseInt(this.$route.query.pno) || this.pageNo;
        this.filter = this.$route.query.f || this.filter;
        this.stepFilter = this.$route.query.sp
          ? this.draftStepList.filter((x) =>
              this.$route.query.sp.includes(x.value)
            )
          : this.stepFilter;
        this.draftTypeFilter = this.$route.query.dt
          ? this.draftTypeList.find((x) => this.$route.query.dt == x.value)
          : this.draftTypeFilter;
        this.stateFilter = this.$route.query.st
          ? this.draftStateList.filter((x) =>
              this.$route.query.st.includes(x.value)
            )
          : this.stateFilter;
        this.selectedIsArchive = this.$route.query.ia
          ? this.ArchiveStateList.find((x) => x.value == this.$route.query.ai)
          : this.selectedIsArchive;
      }
    },
    getData() {
      let stateFilter = "";
      if (this.stepFilter)
        this.stepFilter.forEach(
          (x) => (stateFilter += "stepFilter=" + x.value + "&")
        );
      if (this.stateFilter)
        this.stateFilter.forEach(
          (x) => (stateFilter += "stateFilter=" + x.value + "&")
        );
      const query = {
        ps: this.pageSize,
        pno: this.pageNo,
      };
      if (this.filter) query.f = this.filter;
      if (this.stepFilter) query.sp = this.stepFilter.map((x) => x.value);
      if (this.stateFilter) query.st = this.stateFilter.map((x) => x.value);
      if (this.draftTypeFilter) query.dt = this.draftTypeFilter.value;
      if (this.selectedIsArchive) query.ai = this.selectedIsArchive.value;
      this.$router.replace({
        query: query,
      });

      let payload = {
        params: {
          MaxResultCount: this.pageSize,
          SkipCount: this.pageSize * (this.pageNo - 1),
          Filter: this.filter,
          IsArchived:
            this.selectedIsArchive == null
              ? null
              : this.selectedIsArchive.value,
        },
      };
      if (this.draftTypeFilter)
        payload.params.draftTypeFilter = this.draftTypeFilter.value;
      let loading = this.$vs.loading();

      this.$http
        .get("/api/services/app/Draft/GetAll?" + stateFilter, payload)
        .then((response) => {
          this.transactions2 = response.data.result.items.map((x) => {
            if (!x.draftMerchant) x.draftMerchant = {};
            return x;
          });
          this.totalCount = response.data.result.totalCount;
          this.pagesCount = Math.ceil(this.totalCount / this.pageSize);
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          console.log(error);
          this.$vs.loading.close();
        }); //end http

      // this.$http
      //   .get("api/services/app/Transactions/GetAll", payload)
      //   .then(response => {
      //     this.transactions2 = response.data.result.data.items;
      //   }) //end success
      //   .catch(error => {
      //     console.log(error);
      //   }); //end http
    },
    clear() {
      this.stepFilter = [];
      this.stateFilter = [];
      this.draftTypeFilter = null;
      this.filter = "";
    },
    SetPageSize(val) {
      this.pageSize = val;
      this.pageNo = 1;
      this.getData();
    },
    showTransaction(id) {
      this.$refs.CreateOrEditDraftMerchant1.transactionId = id;
    },
    newMerchant(id) {
      this.$refs.CreateOrEditDraftMerchant1.show();
    },
    editMerchent(tr) {
      if (tr.step == 6) {
        this.$refs.ManagementIbans1.show(
          tr.parentId,
          tr.pspRequestShopAcceptors[0].shop.farsiName
        );
      } else {
        this.$refs.CreateOrEditDraftMerchant1.show(tr.id);
      }
    },
    editStatus(tr, confirm = false) {
      if (!confirm) {
        this.$refs.EditStatusDraftMerchan1.show(
          tr.id,
          tr.pspRequestShopAcceptors[0].shop.farsiName,
          tr.step,
          tr.state
        );
      } else {
        this.$vs.dialog({
          type: "confirm",
          color: "danger",
          title: `تایید`,
          acceptText: "تایید",
          cancelText: "بی‌خیال",
          text: `ویرایش باعث تغییر در وضعیت پذیرنده می شود.
            آیا از ویرایش اطمینان دارید؟`,
          accept: () => {
            this.editStatus(tr, false);
          },
        });
      }
    },
    serverValidation(id, step, state) {
      let loading = this.$vs.loading();
      let validationPath = "DraftShaparak/ValidateShop";
      if (step == 1) validationPath = "Behpardakht/ValidateNewMerchant";
      else if (step == 13) validationPath = "DraftShaparak/ValidateShop";
      else if (step == 5) validationPath = "DraftShaparak/ValidateTerminal";
      this.$http
        .post(`/api/services/app/${validationPath}?throwExeption=true&id=${id}`)
        .then((response) => {
          if (response.data.success) {
            this.$vs.notify({
              time: 5000,
              color: "success",
              title: "موفق!",
              text: "اطلاعات کامل می باشد.",
            });
            this.getData();
          }
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          this.$vs.loading.close();
        }); //end http
    },
    sendToPsp(id) {
      let loading = this.$vs.loading();
      this.$http
        .post(`/api/services/app/Behpardakht/RegisterNewMerchant?id=${id}`)
        .then((response) => {
          if (response.data.success) {
            this.$vs.notify({
              time: 5000,
              color: "success",
              title: "موفق!",
              text: "پذیرنده با موفقیت به بهپرداخت ارسال شد",
            });
            this.getData();
          }
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          this.$vs.loading.close();
        }); //end http
    },
    sendShopToShaparak(id) {
      let loading = this.$vs.loading();
      this.$http
        .post(`/api/services/app/DraftShaparak/RegisterShop?id=${id}`)
        .then((response) => {
          if (response.data.success) {
            this.$vs.notify({
              time: 5000,
              color: "success",
              title: "موفق!",
              text: "پذیرنده با موفقیت به شاپرک ارسال شد",
            });
            this.getData();
          }
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          this.$vs.loading.close();
        }); //end http
    },
    inquiry(id, requestType) {
      let loading = this.$vs.loading();
      let payload = {
        id: id,
        RequestType: requestType,
      };
      this.$http
        .post("/api/services/app/DraftShaparak/ProcessInquiry", payload)
        .then((response) => {
          if (response.data.result.length > 0) {
            if (response.data.result[0].status == 5) {
              this.getData();
              this.$vs.notify({
                time: 5000,
                color: "danger",
                title: "رد!",
                text: `پذیرنده مورد نظر رد شد.`,
              });
              let results = "";
              response.data.result[0].requestRejectionReasons.forEach((x) => {
                results +=
                  x.fieldName +
                  ": " +
                  RequestRejectionReason[x.codeExceptionValue] +
                  "<br>";
              });
              this.$vs.notify({
                time: 4000 + results.length * 80,
                color: "danger",
                title: "دلایل رد شدن:",
                text: results,
              });
            } else if (response.data.result[0].status == 14) {
              this.getData();
              this.$vs.notify({
                time: 5000,
                color: "success",
                title: "موفق!",
                text: "پذیرنده مورد نظر تایید شد.",
              });
            } else {
              this.$vs.notify({
                time: 6000,
                color: "warning",
                title: "انتظار!",
                text: `پذیرنده مورد نظر در انتظار تایید می باشد.`,
              });
            }
          } else {
            this.$vs.notify({
              time: 5000,
              color: "danger",
              title: "خطا!",
              text: "استعلام با شکست مواجه شد",
            });
          }
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          this.$vs.loading.close();
        }); //end http
    },
    sendTerminalToShaparak(id) {
      let loading = this.$vs.loading();
      this.$http
        .post(`/api/services/app/DraftShaparak/RegisterTerminal?id=${id}`)
        .then((response) => {
          if (response.data.success) {
            this.$vs.notify({
              time: 5000,
              color: "success",
              title: "موفق!",
              text: "ترمینال با موفقیت به شاپرک ارسال شد",
            });
            this.getData();
          }
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          this.$vs.loading.close();
        }); //end http
    },
    archive(id) {
      let loading = this.$vs.loading();
      let payload = {
        Id: id,
      };
      this.$http
        .post(`/api/services/app/Draft/Archive`, payload)
        .then((response) => {
          if (response.data.success) {
            this.$vs.notify({
              time: 5000,
              color: "success",
              title: "موفق!",
              text: "پذیرنده آرشیو شد",
            });
            this.getData();
          }
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          this.$vs.loading.close();
        }); //end http
    },
    unArchive(id) {
      let loading = this.$vs.loading();
      let payload = {
        Id: id,
      };
      this.$http
        .post(`/api/services/app/Draft/UnArchive`, payload)
        .then((response) => {
          if (response.data.success) {
            this.$vs.notify({
              time: 5000,
              color: "success",
              title: "موفق!",
              text: "پذیرنده از آرشیو خارج شد",
            });
            this.getData();
          }
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          this.$vs.loading.close();
        }); //end http
    },
    showEditMobile(tr) {
      const name = tr.pspRequestShopAcceptors[0].shop.farsiName;
      const mobile = tr.draftMerchant.cellPhoneNumber;
      this.$refs.EditMobile1.show(tr.id, name, mobile);
    },
    selected(tr) {
      //this.showTransaction(tr.transaction.id);
    },
    fillDefaultSearch(defaultStatus) {
      this.stepFilter = [];
      this.stateFilter = [];
      this.draftStepList.forEach((x) => {
        if (defaultStatus.includes(x.value)) this.stepFilter.push(x);
      });
      this.draftStateList.forEach((x) => {
        if (defaultStatus.includes(x.value)) this.stateFilter.push(x);
      });
      this.pageNo = 1;
      //this.fillTable();
    },
    getL(tr) {
      //this.showTransaction(tr.transaction.id);
    },
    showAsignPromoter(draftId, shopName) {
      this.selectedDrftId = draftId;
      this.$refs.SelectPromoter1.show(null, draftId, shopName);
    },
    assignPromoter(userId) {
      let loading = this.$vs.loading();

      let payload = {
        promoterUserId: userId,
        DraftId: this.selectedDrftId,
      };
      this.$http
        .post(`/api/services/app/Promoters/AsignDraft`, payload)
        .then((response) => {
          if (response.data.success)
            this.$vs.notify({
              time: 5000,
              color: "success",
              title: "موفق!",
              text: "پذیرنده با موفقیت به بازاریاب الصاق شد",
            });
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          console.log(error);
          this.$vs.loading.close();
        });
    },
    unassignPromoter(userId) {
      let loading = this.$vs.loading();

      let payload = {
        id: this.selectedDrftId,
      };
      this.$http
        .post(`/api/services/app/Promoters/UnasignDraft`, payload)
        .then((response) => {
          if (response.data.success)
            this.$vs.notify({
              time: 5000,
              color: "success",
              title: "موفق!",
              text: "پذیرنده از بازاریاب جدا شد",
            });
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          console.log(error);
          this.$vs.loading.close();
        });
    },
  },
  mounted() {
    this.initFilters();
    this.getData();
  },
};
</script>
